import { IoMdCheckmark } from 'react-icons/io';
import { CiWarning } from 'react-icons/ci';
import { splitCamelCase } from '@shared/utils';

export const getResultWithIcon = (cell: 'Passed' | 'Failed' | 'RisksDetected') => {
    if (cell === 'Passed') {
        return (
            <span className={`verification-result-cell ${cell}`}>
                <IoMdCheckmark /> {cell}
            </span>
        );
    } else if (cell === 'Failed') {
        return (
            <span className={`verification-result-cell ${cell}`}>
                <CiWarning /> {cell}
            </span>
        );
    } else {
        return (
            <span className={`verification-result-cell ${cell}`}>
                <CiWarning /> {splitCamelCase(cell, 'every-word')}
            </span>
        );
    }
};
